import React, { useState, useEffect, useMemo } from 'react'
import _ from 'lodash'
import SummaryCodeAmountChips from "../PayCalendarDetailsModal/SummaryCodeAmountChips";

const formatCurrency = (value) => {
    const price = `$${value.toFixed(2)}`;
    return price.replace('$-', '-$');
};

const SortableHeader = ({ children, name, column, order, onClick }) => {
    const direction = order ? 'down' : 'up';
    const isActive = column === name;
    return (
        <th className={`cursorPointer ${isActive ? 'active' : ''}`} onClick={onClick}>
            <div>
                {children}
                {isActive && <i className={`sort amount ${direction} icon ml-05`}></i>}
            </div>
        </th>
    );
};

const AdjustmentTableData = (props) => {
    const { reportData, page, getPracticeName } = props;
    const [column, setColumn] = useState(null);
    const [order, setOrder] = useState(true); // true for 'asc', false for 'desc'
    const [data, setData] = useState(reportData);
    const [selectedAdjType, setSelectedAdjType] = useState(null);

    useEffect(() => {
        setData(reportData);
        setSelectedAdjType(null);
    }, [reportData]);

    const handleSort = (clickedColumn) => {
        if (column !== clickedColumn) {
            setColumn(clickedColumn);
            setOrder(true);
        } else {
            setOrder(!order);
        }
    };

    const sortedData = useMemo(() => {
        if (!column) {
            return data;
        }
        const sorted = _.sortBy(data, [column]);
        return order ? sorted : sorted.reverse();
    }, [data, column, order]);

    const filteredData = useMemo(() => {
        if (!selectedAdjType) return sortedData;
        return sortedData.filter(item => item.ADJ_Type === selectedAdjType);
    }, [sortedData, selectedAdjType]);

    const totalPrice = useMemo(() => filteredData.reduce((sum, item) => sum + item.price, 0), [filteredData]);

    if (!reportData || reportData.length === 0) {
        return (
            <table className="table table-striped table-hover my-0">
                <thead>
                    <tr>
                        <th colSpan="7">No Record Found</th>
                    </tr>
                </thead>
                <tbody></tbody>
            </table>
        );
    }

    return (
        <>
            <div style={{position: 'sticky', top: 0, background: '#fff', zIndex: 2, paddingBottom: '0.5rem'}}>
                <SummaryCodeAmountChips
                    title="Adjustment codes summary:"
                    name="ADJ_Type"
                    value="price"
                    data={sortedData ?? []}
                    selectedCode={selectedAdjType}
                    onCodeClick={setSelectedAdjType}
                />
            </div>
            <div className="table-responsive FreezeTable" style={{maxHeight: '50vh'}}>
            <table className="table table-striped table-hover my-0">
            <thead>
                <tr>
                    {page === 'bGoal' ?
                        <SortableHeader name="drName" column={column} order={order} onClick={() => handleSort('drName')}>DrName</SortableHeader>
                        :
                        <SortableHeader name="practice" column={column} order={order} onClick={() => handleSort('practice')}>Practice</SortableHeader>
                    }
                    <SortableHeader name="patientId" column={column} order={order} onClick={() => handleSort('patientId')}>Patient #</SortableHeader>
                    <SortableHeader name="dateOfService" column={column} order={order} onClick={() => handleSort('dateOfService')}>Date Of Service</SortableHeader>
                    <SortableHeader name="DateEntry" column={column} order={order} onClick={() => handleSort('DateEntry')}>Entry Date</SortableHeader>
                    <SortableHeader name="ProcCode" column={column} order={order} onClick={() => handleSort('ProcCode')}>Procedure Code</SortableHeader>
                    <SortableHeader name="ADJ_Type" column={column} order={order} onClick={() => handleSort('ADJ_Type')}>Adjustment Code</SortableHeader>
                    <SortableHeader name="price" column={column} order={order} onClick={() => handleSort('price')}>Amount</SortableHeader>
                </tr>
            </thead>
            <tbody>
                {filteredData.map((item, index) => (
                    <tr key={index}>
                        <td>{page === 'bGoal' ? item.drName : item.Practice ? getPracticeName(item.Practice) : item.practiceName}</td>
                        <td>{item.patientId}</td>
                        <td>{item.dateOfService}</td>
                        <td>{item.DateEntry}</td>
                        <td>{item.ProcCode}</td>
                        <td>{item.ADJ_Type}</td>
                        <td>{formatCurrency(item.price)}</td>
                    </tr>
                ))}
                <tr key="total">
                    <td colSpan="6"><b>Total</b></td>
                    <td colSpan="1"><b>{formatCurrency(totalPrice)}</b></td>
                </tr>
            </tbody>
        </table>
        </div>
        </>
    );
}

export default AdjustmentTableData;
